import { NgModule } from '@angular/core';
import { TableModule } from 'primeng/table';
import { TableComponent } from './table.component';
import { CommonModule } from '@angular/common';
import { BadgeComponentModule } from '../badge/badge-component.module';
import { ChipComponentModule } from '../chip/chip-component.module';
import { ButtonComponentModule } from '../button/button-component.module';

@NgModule({
  declarations: [TableComponent],
  imports: [
    CommonModule,
    TableModule,
    BadgeComponentModule,
    ChipComponentModule,
    ButtonComponentModule,
  ],
  exports: [TableComponent],
})
export class TableComponentModule {}
